import { gql, useQuery } from '@apollo/client'

const TraceServiceGroupQueryQL = gql(`
  query ServiceGroups($queryParams: QueryParams) {
    traceServiceGroups(queryParams: $queryParams) {    
      serviceName
      name
      totalSize
      count
      timestamp
    }
  }
`)

const TraceAttributeGroupQueryQL = gql(`
  query TraceAttributeGroup($queryParams: SpanAttributeQueryParams) {
    spanAttributes(queryParams: $queryParams) {
      name
      values {
        value
        count
      }
    }
  }
`)

const SpansByServiceQueryQL = gql(`
  query SpansByService($queryParams: TraceServiceQueryParams) {
    spansByService(queryParams: $queryParams) {
      record
      duration
    }
  }
`)
const TracesWithAttributeValueQL = gql(`
  query TracesWithAttributeValue($queryParams: TracesWithAttributeValueParams!) {
    tracesWithAttributeValue(queryParams: $queryParams) {
      record
      duration
    }
  }
`)

const FullTraceQueryQL = gql(`
  query FullTrace($traceId: String) {
    fullTrace(traceId: $traceId) {
      totalDuration
      traces {
        record
        duration
      }
    }
  }
`)

export function TraceServiceGroupQuery({
  startTime,
  endTime,
  from = '',
  where = '',
  limit = 100,
  offset = 0,
  orderBy = { column: 'total_size', direction: 'desc' },
}: {
  startTime: string
  endTime: string
  from: string
  where: string
  limit?: number
  offset?: number
  orderBy?: { column: string; direction: string }
}) {
  const { loading, error, data } = useQuery(TraceServiceGroupQueryQL, {
    variables: {
      queryParams: {
        startTime,
        endTime,
        from,
        where,
        limit,
        offset,
        orderBy,
      },
    },
  })

  return { loading, error, data }
}

export function TraceAttributeGroupQuery({
  startTime,
  endTime,
  limit = 10,
  offset = 0,
  where = '',
  orderBy = { column: 'count', direction: 'desc' },
}: {
  startTime: string
  endTime: string
  limit?: number
  offset?: number
  where?: string
  orderBy?: { column: string; direction: string }
}) {
  const { loading, error, data } = useQuery(TraceAttributeGroupQueryQL, {
    variables: {
      queryParams: {
        startTime,
        endTime,
        limit,
        offset,
        where,
        orderBy,
      },
    },
  })

  return { loading, error, data }
}

export function SpansByServiceQuery({
  startTime,
  serviceName,
  name,
}: {
  startTime: string
  serviceName: string
  name: string
}) {
  const { loading, error, data } = useQuery(SpansByServiceQueryQL, {
    variables: {
      queryParams: {
        startTime,
        serviceName,
        name,
      },
    },
  })

  return { loading, error, data }
}

export function TracesWithAttributeValueQuery({
  startTime,
  endTime,
  attribute,
  value,
  limit,
}: {
  startTime: string
  endTime: string
  attribute: string
  value: string
  limit: number
}) {
  const { loading, error, data } = useQuery(TracesWithAttributeValueQL, {
    variables: {
      queryParams: {
        startTime,
        endTime,
        attribute,
        value,
        limit,
      },
    },
  })

  return { loading, error, data }
}

export function FullTraceQuery({ traceId }: { traceId: string }) {
  const { loading, error, data } = useQuery(FullTraceQueryQL, {
    variables: {
      traceId,
    },
  })

  return { loading, error, data }
}
